import { logError } from "@service/ConsoleLoggerService";
import { ClarityEvent } from "./ClarityEvents";

declare global {
    interface Window {
        clarity(
            command: "identify",
            customId: string,
            customSessionId?: string,
            customPageId?: string,
            friendlyName?: string,
        ): Promise<{ id: string }>;
        clarity(command: "event", value: string): void;
    }
}

/** Never throw. */
export async function identifyClarity(uid: string) {
    try {
        await window.clarity("identify", uid);
    } catch (e) {
        logError("Failed to identify Clarity user.");
        logError(String(e));
    }
}

/** Never throw. */
export function sendClarityEvent(event: ClarityEvent) {
    try {
        window.clarity("event", event);
    } catch (e) {
        logError("Failed to send Clarity event.");
        logError(String(e));
    }
}
